var $ = global.jQuery = global.$;

var _Base = require('./_Base');

/**
 * Article open/close
 * @class
 * @extends _Base
 */
var Article = _Base.extend(
  /** @lends Article.prototype */
  {
  /**
   * Initialises the article
   * @private
   */
  init: function() {
    var self = this;

    this.$close = this.$el.find('[data-article-close]');

    this.returnScrollPosition = this.$el.offset().top;

    this.$close.on('click', function(event) {
      event.preventDefault();
      self.close();
    });

  },
  /**
   * Close the article
   */
  close: function() {
    this.$el.velocity('slideUp');
    $(window).scrollTop(this.returnScrollPosition);
  }
});

module.exports = Article;



/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/widgets/Article.js
 ** module id = 41
 ** module chunks = 0 1
 **/